let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("adH3p"), load("gP6i7")]).then(() => parcelRequire('2rHP3'));